import { IconName } from '@bytel/trilogy-react';

export enum FaiTabsEnum { // also used as url hash
    SMART_TV_GAMING = 'smart',
    PURE_BYOU = 'purebyou',
    BOX_INTERNET = 'box-internet',
    BOX_5G = '5gbox',
    BIG = 'big',
}

export type TabConfigItem = {
    name: string;
    icon: IconName;
    order: number;
};

export type TabConfig = {
    [key in FaiTabsEnum]?: TabConfigItem;
};
